/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Onboarding_Pilot_How_TitleInputs */



/**
* | output |
* | --- |
* | "What you do over the next {weeks} weeks" |
*
* @param {Onboarding_Pilot_How_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_title = /** @type {((inputs: Onboarding_Pilot_How_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Wat je de komende ${i?.weeks} weken doet`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce que vous faites au cours des ${i?.weeks} prochaines semaines`)
	return /** @type {LocalizedString} */ (`What you do over the next ${i?.weeks} weeks`)
});